var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageCheckOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H2C1.71875 2 1.5 2.25 1.5 2.5V12.5C1.5 12.7812 1.71875 13 2 13H12C12.25 13 12.5 12.7812 12.5 12.5V2.5C12.5 2.25 12.25 2 12 2ZM2 0.5H12C13.0938 0.5 14 1.40625 14 2.5V12.5C14 13.625 13.0938 14.5 12 14.5H2C0.875 14.5 0 13.625 0 12.5V2.5C0 1.40625 0.875 0.5 2 0.5Z",
    fill: "#8791B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageCheckOff);
export default __webpack_public_path__ + "static/media/language-check-off.6f3101063579f2116e8416eea77724ca.svg";
export { ForwardRef as ReactComponent };